import OverlayTips from "../OverlayTips";

function ReportPageOverlayTipsManager(titleMessageKey)
{
    PageOverlayTipsManager.call(this);
    this._titleMessageKey = titleMessageKey;
}

ReportPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle"), {
            messageKey: this._titleMessageKey,
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            }
        });

        this.add($(".controlsContainer"), {
            messageKey: "tips.report.controls",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -40,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -10,
                offsetY: 60
            }
        });

        this.add($(".rightContainer .tabs"), {
            messageKey: "tips.report.format",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -20,
            offsetY: -20
        });

        this.add($(".previewCell"), {
            messageKey: "tips.report.preview",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -5,
            offsetY: 100
        });
    }
});

export default ReportPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/ReportPageOverlayTipsManager.js